import { Controller } from 'stimulus';

/* Hides specific Trix toolbar buttons/groups for editors where certain
   formatting shouldn't be offered (e.g. no headings, code blocks, or
   attachments). Configure which to remove via data values, matching the
   attribute/group names Trix's own default toolbar markup uses:
     - buttons carry [data-trix-attribute="..."], e.g. "heading1", "code"
     - button groups carry [data-trix-button-group="..."], e.g. "file-tools"
   Usage: add data-controller="trix-restricted-toolbar" alongside
   data-trix-restricted-toolbar-hide-attributes-value='["heading1","code"]'
   and/or data-trix-restricted-toolbar-hide-groups-value='["file-tools"]'
   to an element that contains the trix-editor (or is the trix-editor
   itself). */

export default class TrixRestrictedToolbarController extends Controller {
  static values = {
    hideAttributes: { type: Array, default: [] },
    hideGroups: { type: Array, default: [] }
  };

  connect() {
    const toolbarElement = this.findToolbarElement();
    if (!toolbarElement) return;

    this.hideAttributesValue.forEach((attribute) => {
      toolbarElement.querySelector(`[data-trix-attribute="${attribute}"]`)?.remove();
    });

    this.hideGroupsValue.forEach((group) => {
      toolbarElement.querySelector(`[data-trix-button-group="${group}"]`)?.remove();
    });
  }

  findToolbarElement() {
    return this.element.querySelector('trix-toolbar') || this.element.closest('trix-editor')?.toolbarElement;
  }
}
